<div class="preferences-settings" data-automation-id="preferences-settings-container">
    <div class="header-bar" data-automation-id="preferences-settings-header'">
        <button type="button" data-automation-id="preferences-settings-save-button" class="primary-button"
            (click)="saveChanges()" *ngIf="hasPermission" [disabled]="isSaveDisabled()">Save</button>
        <button type="button" data-automation-id="preferences-settings-discard-changes-button" class="secondary-button"
            (click)="discardChanges()" *ngIf="hasPermission" [disabled]="isDiscardDisabled()">Discard
            Changes</button>
        <button type="button" class="help-button" data-automation-id="preferences-settings-help-button'"
            (click)="openHelp()" *ngIf="isHelpIndex">
            <i class="fa fa-question"></i>
        </button>
    </div>

    <form class="content" #contentForm="ngForm" [resBusySpinner]="isBusy" [message]="isBusyMessage"
        data-automation-id="preferences-settings-content">

        <div *ngIf="settingsType === 'project'">
            <div class="header-cell">
                <span>General</span>
            </div>
            <div class="modal-row" style="margin-bottom: 20px;">
                <div class="modal-row-column-auto">
                    <label [class.disabled]="!hasPermission">Time zone:</label>
                </div>
                <div class="modal-row-column-auto">
                    <select class="timezone" [(ngModel)]="viewModel.selectedTimezone" (change)="selectionChange()"
                        [disabled]="!hasPermission" name="viewModel.selectedTimezone"
                        data-automation-id="preferences-general-time-zone-option">
                        <option *ngFor="let entry of timeZonesList" [ngValue]="entry" [disabled]="disabledSpace(entry)">
                            {{entry.description}} </option>
                    </select>
                </div>
            </div>
            <div class="header-cell">
                <span>eDiscovery</span>
            </div>
            <div class="modal-row">
                <label class="modal-row-column-auto"
                    [attr.data-automation-id]="automationId + '-archival-time-start-label'"
                    [class.disabled]="!hasPermission">Archive items after:</label>
                <res-custom-input class="modal-row-column-auto" [field]="viewModel.model.lastAccessTimeForArchival"
                    [inputType]="'number'" [customWidth]="'53px'" [inputNumberMaxLength]="4" name="achivalTime"
                    [automationId]="automationId + '-archival-time'" [hideClearBtn]="true" [inputNumberMinValue]="1"
                    [queryFocusChanged]="onArchivalTimeChanged.bind(this, viewModel.model.lastAccessTimeForArchival)">
                </res-custom-input>
                <label [class.disabled]="!hasPermission"
                    [attr.data-automation-id]="automationId + '-archival-time-end-label'">days
                    since last access</label>
            </div>
            <div class="modal-row">
                <res-custom-checkbox [automationId]="automationId + '-hide-archived-items-in-navigation-tree'"
                    content="Hide Archived Items in Navigation Tree" name="hideArchivedItems"
                    [(ngModel)]="viewModel.model.suppressArchivedNavTree" [disabled]="!hasPermission">
                </res-custom-checkbox>
            </div>
            <div class="modal-row" style="margin-bottom: 20px;">
                <res-custom-checkbox [automationId]="automationId + '-general-hide-duplicates-in-lists'"
                    content="Hide Duplicates in Lists" name="hideDuplicates"
                    [(ngModel)]="viewModel.model.suppressDuplicates" [disabled]="!hasPermission">
                </res-custom-checkbox>
            </div>
            <div class="header-cell" [hidden]="!isReview">
                <span>Review</span>
            </div>
            <div class="modal-row" [hidden]="!isReview">
                <res-custom-checkbox [disabled]="!hasPermission"
                    [automationId]="automationId + '-general-background-html-conversion-caching'"
                    content="Background HTML Conversion & Caching" name="HTMLCaching"
                    [(ngModel)]="viewModel.model.htmlConversionCacheEnabled"></res-custom-checkbox>
            </div>
        </div>

        <div *ngIf="settingsType === 'organization'" class="preferences-container">
            <div class="preferences-header">
                <div class="header">
                    <span requiredAsterisk>Available Project Setup Options</span>
                </div>
                <div class="header">
                    <span requiredAsterisk>Selected by Default</span>
                </div>
            </div>
            <div class="preferences-content" [ngClass]="{'disabled': !hasPermissions}">
                <div class="preferences-item">
                    <res-custom-checkbox [isDisabled]="!hasPermission" name="DIGITAL_REEF_ONLY"
                        [automationId]="automationId + '-digital-reef-only-checkbox'"
                        [(ngModel)]="availableProjectSetupOptions['DIGITAL_REEF_ONLY']" content="Reef ECA Only"
                        (ngModelChange)="onChange($event)">
                    </res-custom-checkbox>
                    <res-custom-radio-button [iconTooltip]="isDROnlyOption ? tooltip : ''"
                        [isDisabled]="!hasPermission || isDROnlyOption"
                        [automationId]="automationId + '-digital-reef-only'" (ngModelChange)="onChange($event)"
                        [(ngModel)]="viewModel.model.autoProjectCreation" name="autoProjectCreation"
                        value="Digital_Reef_Only"></res-custom-radio-button>
                </div>
                <div class="preferences-item">
                    <res-custom-checkbox [isDisabled]="!hasPermission" name="DIGITAL_REEF_AND_RELATIVITY"
                        [automationId]="automationId + '-digital-reef-and-relativity-checkbox'"
                        [(ngModel)]="availableProjectSetupOptions['DIGITAL_REEF_AND_RELATIVITY']"
                        content="Reef ECA and Relativity" (ngModelChange)="onChange($event)">
                    </res-custom-checkbox>
                    <res-custom-radio-button [iconTooltip]="isReefAndRelativityOption ? tooltip : ''"
                        [isDisabled]="!hasPermission || isReefAndRelativityOption"
                        [automationId]="automationId + '-digital-reef-and-relativity'"
                        (ngModelChange)="onChange($event)" [(ngModel)]="viewModel.model.autoProjectCreation"
                        name="autoProjectCreation" value="Digital_Reef_and_Relativity"></res-custom-radio-button>
                </div>
                <div class="preferences-item">
                    <res-custom-checkbox [isDisabled]="!hasPermission" name="DIGITAL_REEF_AND_REEF_REVIEW"
                        [automationId]="automationId + '-digital-reef-and-reef-review-checkbox'"
                        [(ngModel)]="availableProjectSetupOptions['DIGITAL_REEF_AND_REEF_REVIEW']"
                        (ngModelChange)="onChange($event)" content="Reef ECA and Reef Review"
                        [popoverErrorMessage]="checkboxErrorMessage" popoverType="error"
                        [(resScrollablePopover)]="checkboxValidation" [isSingleLine]="true" popoverPlacement="bottom"
                        [popoverAutomationId]="automationId + '-checkbox-error-message'" [popoverOffsetLeft]="3">
                    </res-custom-checkbox>
                    <res-custom-radio-button [iconTooltip]="isReefAndRROption ? tooltip: ''"
                        [isDisabled]="!hasPermission || isReefAndRROption"
                        [automationId]="automationId + '-digital-reef-and-reef-review'"
                        [(ngModel)]="viewModel.model.autoProjectCreation" name="autoProjectCreation"
                        value="Digital_Reef_and_Reef_Review" [popoverErrorMessage]="radioButtonErrorMessage"
                        popoverType="error" [(resScrollablePopover)]="radioButtonValidation" [isSingleLine]="true"
                        popoverPlacement="bottom" (ngModelChange)="onChange($event)"
                        [popoverAutomationId]="automationId + '-radio-button-error-message'"
                        [popoverOffsetLeft]="88"></res-custom-radio-button>
                </div>
            </div>
            <!-- Code below it is the implementation ( with style see .scss ) for the entire prototype options for ECASL-39025. -->
            <!-- <div class="modal-row">
                <div class="modal-row-column-auto">
                    <label>Default Processing Option for New Data Sets:</label>
                </div>
                <div class="modal-row-column-auto radio-column align-items">
                    <res-custom-radio-button [isDisabled]="!hasPermission"
                        [automationId]="automationId + '-import-into-digital-reef-only'"
                        [(ngModel)]="viewModel.model.defaultProcessingOption" content="Import into Reef ECA Only"
                        name="defaultProcessingOption" value="Import_into_Digital_Reef_Only"></res-custom-radio-button>
                    <res-custom-radio-button [isDisabled]="!hasPermission"
                        [automationId]="automationId + '-import-into-digital-reef-and-export-to-selected-review-tool'"
                        [(ngModel)]="viewModel.model.defaultProcessingOption"
                        content="Import into Reef ECA and Export to Selected Review Tool"
                        name="defaultProcessingOption"
                        value="Import_into_Digital_Reef_and_Export_to_Selected_Review_Tool"></res-custom-radio-button>
                </div>
            </div> -->
        </div>

    </form>

</div>